export default "__VITE_ASSET__Bbrh98xj__"